import { defineComponent, h, markRaw } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import filters from '../../../Shared/filters';
import computed from '../../../Shared/computed';
import EventBus from '@/Application/event-bus.js';
import careHelpfulFunctions from '../../careHelpfulFunctions.jsx';

import { QToolbar, QToolbarTitle, QSpace, QBtn, QIcon, QCard, QCardSection, QCardActions } from 'quasar';
import VerticalStack from '../VerticalStack.jsx';

const BusyIcon = {
    components: { QIcon },
    render() {
        return (
            <QIcon
                name="mdi-cloud-download"
                size="sm"
                color="white"
                style={{ visibility: utils.global_variables.api_busy_indicator ? 'visible' : 'hidden' }}
            />
        );
    }
};

export default defineComponent({
    name: 'DisplayBasicModal',
    inheritAttrs: false,
    emits: ['closeme'],
    provide() {
        const dialogName = this.getDialogName();
        return {
            dialogBasicModalBodySingleScroll: true,
            dialogScopeitems: this.dialogScopeitems,
            dialogName: dialogName || null,
            dialogNamed: this.isDialogNamed(),
        };
    },
    components: {
        BusyIcon,
        VerticalStack,
        QToolbar,
        QToolbarTitle,
        QSpace,
        QBtn,
        QIcon,
        QCard,
        QCardSection,
        QCardActions
    },
    data: () => ({
        _uid: utils._uid_counter++,
        isbase: true,
        _allchildren: {},
        _children: [],
        vars: {},
        value: '',
        cc_form_changed_indicator: false,
        cc_form_changed_active: false,
        cc_form_changed_linked: false,
        cc_form_changed_button: null,
        cc_form_changed_form: null,
        dialogScopeitems: markRaw({}),
    }),
    props: {
        name: '',
        root: null,
        type: null,
        parentType: '',
        action: null,
        context: null,
        c_context: null,
        controlData: { default: () => ({}) },
        scopeitems: null,
        controlscope: null,

        okay: null,
        cancel: null,
        accept: null,
    },
    created() {
        this.cc_form_changed_active = !this.action.ActionData.DisableFormTracking;
        this.titlerenderer = utils.compile(this, this.Translate(this.action.ActionData.Title));

        if (this.action.ActionData && this.action.ActionData.Vars) {
            const varsexpn = utils.compileObject(this, this.action.ActionData.Vars);
            try {
                this.vars = utils.evaluateObject(varsexpn, this.action.context);
            }
            catch (e) {
                utils.log('error evaluating Vars: ' + e);
            }
        }

        if (this.action.ActionData && this.action.ActionData.Javascript)
            try {
                const api = utils.apiWrapper;
                const chf = careHelpfulFunctions;
                this.Javascript = utils.instantiateDynamicControllerScoped(this.action.ActionData.Javascript, { api, contextThis: this, chf }, 'null, null, api, contextThis, chf');

                for (let key in this.Javascript)
                    if (typeof this.Javascript[key] === 'function')
                        this.Javascript[key] = this.Javascript[key].bind(this.Javascript);
            }
            catch (e) {
                utils.warn(`Failed evaluating Javascript in ${this.name} ${this.type}: ${this.action.ActionData.Javascript}`, e);
            }

        utils.debug(`DialogBasicModal ${this.name} ${this._uid} $on ActionClose`);
        this.$on('Action-Close', this.performClose);
        EventBus.$on(`Action-Close:${this.name}`, this.performClose);
        EventBus.$on(`Action-Close`, this.performClose);
    },
    mounted() {
        this.publishDialogToControl();
    },
    unmounted() {
        this.unpublishDialogFromControl();

        utils.debug(`DialogBasicModal ${this.name} ${this._uid} $off ActionClose`);
        this.$off('Action-Close', this.performClose);
        EventBus.$off(`Action-Close:${this.name}`, this.performClose);
        EventBus.$off(`Action-Close`, this.performClose);
    },
    computed: {
        ...computed,
        Base() {
            return this;
        },
        Name() {
            return this.name;
        },
        Root() {
            return this.root ? this.root : this;
        },
        Vars() {
            return this.vars;
        },
        title() {
            return utils.evaluate(this.titlerenderer, this.action.context);
        },
        Input() {
            if (this.context)
                return this.context.Input;
            else
                return null;
        },
        formChangedIndicator() {
            if (!this.cc_form_changed_active)
                return false;

            if (!this.cc_form_changed_button?.prerender_complete)
                return false;

            if (!this.cc_form_changed_form?.prerender_complete)
                return false;

            return this.cc_form_changed_indicator;
        },
        AllowClose() {
            if (this.cc_form_changed_active && this.cc_form_changed_linked)
                return !this.cc_form_changed_indicator;

            return true;
        }
    },
    methods: {
        ...methods,
        ...filters,
        getDialogName() {
            const name = this.name || this.action?.ActionData?.Name;
            if (!name || !String(name).trim())
                return '';
            return String(name).trim();
        },
        isDialogNamed() {
            return Boolean(this.getDialogName());
        },
        publishDialogToControl() {
            const dialogName = this.getDialogName();
            if (dialogName && this.scopeitems)
                this.scopeitems[dialogName] = this.dialogScopeitems;
        },
        unpublishDialogFromControl() {
            const dialogName = this.getDialogName();
            if (dialogName && this.scopeitems && this.scopeitems[dialogName] === this.dialogScopeitems)
                delete this.scopeitems[dialogName];
        },
        confirm() {
            this.okay();
            this.accept(this.value);
        },
        generateItems(h, Controls, items) {
            for (let i = 0; i < Controls.length; i++) {
                const c = Controls[i];

                let DynamicControl = utils.getDynamicComponent(h, c);
                if (!DynamicControl) {
                    items.push(<div>Control type of {c.ControlType} is unknown</div>);
                    continue;
                }

                items.push(
                    <DynamicControl
                        key={i}
                        onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                        type={c.ControlType}
                        name={c.ControlData.Name}
                        root={this.root}
                        parentType="HorizontalStack"
                        controlData={c.ControlData}
                        controlURL={c.ControlURL}
                        controlName={c.Name}
                        accessPermission={c.AccessPermission}
                        scopeitems={this.scopeitems}
                        dialogScopeRegistry={this.dialogScopeitems}
                        dialogNamed={this.isDialogNamed()}
                        controlscope={this.controlscope}
                        cacheControl={c.CacheControl}
                        controlEvents={c.Events}
                    >
                    </DynamicControl>
                );
            }
        },
        formChanged() {
            if (!this.cc_form_changed_active)
                return;

            if (!this.cc_form_changed_button?.prerender_complete)
                return;

            if (!this.cc_form_changed_form?.prerender_complete)
                return;

            this.cc_form_changed_indicator = true;
        },
        async performClose(action) {
            utils.log(' ** Close Action Received by DialogBasicModal **');

            const dialogresult = action.dialogResult ? utils.evaluateObject(action.dialogResult, action.context) : {};

            this.$emit('closeme', {
                Success: action.ActionData ? action.ActionData.Success : true,
                DialogResult: dialogresult,
                AllowClose: true
            });

            try {
                await utils.success(action);
            } catch (e) { }

            action.FinishFunc(true);
        },
        finishRenderHandler(component) {
            if (component && component.$.uid !== this.$.uid) {
                if (!this._children.some(c => c.$.uid === component.$.uid))
                    this._children.push(component);
            }
        },
        clickedOutside(e) {
            e.stopPropagation();
            e.preventDefault();

            if (this.action.ActionData.CloseOnClickOutside != false) {
                if ((this.cc_form_changed_active && !this.cc_form_changed_linked) || this.action.ActionData.CloseOnClickOutside) {
                    this.$emit('closeme', {
                        Success: this.action.ActionData ? this.action.ActionData.Success : true,
                        DialogResult: false,
                        AllowClose: true
                    });
                }
            }
        }
    },
    render() {
        const startMax = this.action.ActionData?.StartMaximized;
        const bodyUsesFlexFill = Boolean(startMax || this.action.ActionData?.AllowResize);

        const body = (
            <VerticalStack
                key={utils.generateUUID()}
                onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                type="VerticalLayout"
                name={this.action.ActionData.Body.Name}
                root={this.root}
                parentType="DialogBasicModal"
                controlData={this.action.ActionData.Body}
                scopeitems={this.scopeitems}
                dialogScopeRegistry={this.dialogScopeitems}
                dialogNamed={this.isDialogNamed()}
                controlscope={this.controlscope}
                input={this.Input}
                style={bodyUsesFlexFill ? { flex: '1 1 auto', minHeight: 0 } : undefined}
            >
            </VerticalStack>
        );

        const footer = [];

        if (this.action.ActionData.Footer && this.action.ActionData.Footer.Controls)
            this.generateItems(h, this.action.ActionData.Footer.Controls, footer);

        let header = null;

        if (!this.action.ActionData.HideTitleBar) {       
            header = (
                <QToolbar class="bg-navigation text-white" style={{ maxHeight: '60px', height: '60px', flexShrink: 0, backgroundColor: 'var(--v-navigation-base)' }}>
                    <QToolbarTitle class="title text-white q-pl-none">
                        {this.title}
                    </QToolbarTitle>
                    <QSpace style="flex-grow: 0 !important;" />
                    <BusyIcon></BusyIcon>
                    <QBtn flat dense color="white" onClick={e =>
                        this.$emit('closeme', {
                            Success: this.action.ActionData ? this.action.ActionData.Success : true,
                            DialogResult: false,
                            AllowClose: this.AllowClose
                        })}>
                        <QIcon name="mdi-close" />
                    </QBtn>
                </QToolbar>
            );
        }

        let content = (
            <QCard style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
                {header}

                <QCardSection
                    style={{
                        paddingTop: '8px',
                        flex: '1 1 auto',
                        minHeight: 0,
                        overflow: 'auto',
                        ...(bodyUsesFlexFill ? { display: 'flex', flexDirection: 'column' } : {})
                    }}
                >
                    {body}
                </QCardSection>

                <QCardActions align="right" style={{ flexShrink: 0 }}>
                    {footer}
                </QCardActions>
            </QCard>
        );

        return content;
    }
});